import { connect } from 'react-redux';
import theme from '../../../../../../components/ui-kit/themes/theme';
import { Text } from '../../../../../ui-kit';
import { SummaryContent } from '../../../Content';
import { getBookingSummaryParkingFee } from '../../../../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';

const ParkingFee = ({ bookingSummaryParkingFee }) => {
  return (
    <>
      {bookingSummaryParkingFee ? (
        <SummaryContent.Item id="BookingSummaryParkingFee">
          <Text
            textAlign="left"
            fontWeight={theme.fontWeights.medium}
            color="deepLakeBlue.100"
            fontSize={9}
            lineHeight="16px">
            {bookingSummaryParkingFee}
          </Text>
        </SummaryContent.Item>
      ) : null}
    </>
  );
};

const mapStateToProps = state => ({
  bookingSummaryParkingFee: getBookingSummaryParkingFee(state.lodgeConfig)
});

export default connect(mapStateToProps, null)(ParkingFee);
